// A retry of pending revocations (POST /power/admin/opin/receiver/revocations/retry): one to
// OPIN_CONSENT_LIFECYCLE_LIST_CAP distinct connections, each sent again with the reason its
// revocation was first asked with, never one the request states.
import { Schema } from 'effect';
import {
  OPIN_CONSENT_LIFECYCLE_LIST_CAP,
  OpinConnectionId,
} from '../consent-lifecycle/consent-lifecycle.ts';

/** The connections whose pending revocations the operator retries, in the order it lists them. */
export const OpinReceiverRevocationRetry = Schema.Struct({
  connectionIds: Schema.Array(OpinConnectionId).check(
    Schema.isMinLength(1),
    Schema.isMaxLength(OPIN_CONSENT_LIFECYCLE_LIST_CAP),
    Schema.isUnique(),
  ),
});
export type OpinReceiverRevocationRetry = typeof OpinReceiverRevocationRetry.Type;

/**
 * What became of one retry: the receiver took it (`accepted`); the connection does not wait on a
 * revocation Power can retry (`not_pending`); another revocation of it is already running
 * (`in_flight`); the operator's role may not revoke for its stored reason (`not_allowed`); no such
 * connection (`not_found`); or the receiver failed it (`failed`).
 */
export const OPIN_RECEIVER_RETRY_OUTCOMES = [
  'accepted',
  'not_pending',
  'in_flight',
  'not_allowed',
  'not_found',
  'failed',
] as const;
export const OpinReceiverRetryOutcome = Schema.Literals(OPIN_RECEIVER_RETRY_OUTCOMES);
export type OpinReceiverRetryOutcome = typeof OpinReceiverRetryOutcome.Type;

/** Each requested connection's outcome, in the order the request listed them. */
export const OpinReceiverRevocationRetryReport = Schema.Struct({
  results: Schema.Array(
    Schema.Struct({ connectionId: OpinConnectionId, outcome: OpinReceiverRetryOutcome }),
  ),
});
export type OpinReceiverRevocationRetryReport = typeof OpinReceiverRevocationRetryReport.Type;
